/* global Version, DataDogService */

import { datadogRum } from '@datadog/browser-rum';
import { isStaticRender } from './ContentHelper';

export default function initializeDataDog() {
  const { dataDog: dataDogConfig } = window.ExternalConfig;
  if (!isStaticRender() && DataDogService && dataDogConfig) {
    const { applicationId, clientToken, env, site } = dataDogConfig;
    datadogRum.init({
      applicationId,
      clientToken,
      site,
      service: DataDogService,
      env,
      version: Version,
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.setGlobalContext({
      business_unit: 'foxnow',
      application: 'web',
      owner: 'fox-now-web',
    });
    datadogRum.startSessionReplayRecording();
  }
}
